/* Handles mode copy inserted after Liquid rendering, including section refreshes. */
(() => {
  if (window.ivoriBoostModeNaming) return;
  window.ivoriBoostModeNaming = true;
  const normalize = value => value
    .replace(/\bwhitening[\s\u00a0]+mode(s?)\b/gi, (_, plural) => `Boost+ mode${plural}`)
    .replace(/\b(gum massage,?\s+and)\s+whitening\b/gi, '$1 Boost+ mode');
  const skip = 'script,style,code,pre,noscript,textarea,[contenteditable]';
  const attributes = ['alt', 'title', 'aria-label'];
  function updateText(node) {
    if (node.parentElement?.closest(skip)) return;
    let value = normalize(node.nodeValue || '');
    if (/^\s*whitening\s*$/i.test(value) && node.parentElement?.closest('.story-mode-grid,[data-cinema-mode],.ivori-mode-options')) {
      value = value.replace(/whitening/i, 'Boost+ mode');
    }
    if (value !== node.nodeValue) node.nodeValue = value;
  }
  function updateAttributes(node) {
    if (!(node instanceof Element) || node.closest(skip)) return;
    for (const attribute of attributes) {
      const original = node.getAttribute(attribute);
      if (original === null) continue;
      const value = normalize(original);
      if (value !== original) node.setAttribute(attribute, value);
    }
  }
  function visit(node) {
    if (node.nodeType === Node.TEXT_NODE) {updateText(node);return;}
    if (!(node instanceof Element) || node.closest(skip)) return;
    updateAttributes(node);
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    let child;
    while ((child = walker.nextNode())) updateText(child);
    node.querySelectorAll('[alt],[title],[aria-label]').forEach(updateAttributes);
  }
  const queued = new Set();
  let scheduled = false;
  function flush() {
    scheduled = false;
    const batch = [...queued];queued.clear();
    batch.forEach(node => {if (node.isConnected) visit(node);});
  }
  function start() {
    visit(document.body);
    document.querySelectorAll('head meta[content]').forEach(meta => {
      const renamed = normalize(meta.content);
      if (meta.content !== renamed) meta.content = renamed;
    });
    const title = normalize(document.title);
    if (title !== document.title) document.title = title;
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'childList') record.addedNodes.forEach(node => queued.add(node));
        else queued.add(record.target);
      }
      if (queued.size && !scheduled) {scheduled = true;queueMicrotask(flush);}
    }).observe(document.body, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: attributes});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
